
let Roles = require('@/mixins/Management/Roles')
let Searchable = require('@/mixins/Searchable')
let Paginator = require('@/mixins/Paginator')

module.exports = {

    mixins: [Roles, Searchable, Paginator],

    data() {
        return {
            users: [],
            displayUser: null,
        }
    },

    mounted() {
        this.fetchUsers()
    },

    methods: {

        requestPaginate: _.debounce(function () {
            this.fetchUsers();
        }, 300),

        fetchUsers() {
            App.request().get(`/management/users?page=${this.paginator.current_page}&per_page=${this.paginator.per_page}&query=${this.searchKey}&paginate`).then(response => {
                this.paginator = response.data;
                this.users = this.paginator.data;
                if (this.users.length) this.displayUser = this.users[0];
                this.fetchRoles();
            })
        },

        loginAs(user) {
            App.request().post(`/management/users/${user.slug}/sign-in-as`).then(response => {
                this.redirectTo('/');
            })
        },

        deleteUser(user) {
            this.displayUser = user;
            this.openModal('delete-user');
        },

        showProjects(user) {
            Storage.set(App.config.userProjectsKey, {
                user_id: user.id,
                searchKey: '',
                page: 1,
                no_completed: false,
            })
            this.redirectTo('/projects');
        }
    },
}
